import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { customStringsAccessControl } from '../access-control/customStringsAccess.configuration'

const CustomStringsListPage = lazy(() => import('../pages/list/CustomStringsListPage'))
const CustomStringsDetailPage = lazy(() => import('../pages/detail/CustomStringsDetailPage'))
// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const customStringsAdminRouter = (
  <DomainRoute route="custom-strings" accessControl={customStringsAccessControl}>
    <DashSwitch>
      <DomainRoute exact route="custom-strings-list" component={CustomStringsListPage} />
      <DomainRoute exact route="custom-strings-detail" component={CustomStringsDetailPage} />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
